import type { Edge2dExtracted, EdgeMap, Node2dExtracted, NodeMap } from "."

export type Mesh = { nodes: NodeMap; edges: EdgeMap }

export type SeparateMeshes = (mesh: Mesh) => Mesh[]

export const getNodeB = (
  node: Node2dExtracted,
  edge: Edge2dExtracted,
): Node2dExtracted => (node.id === edge.p1.id ? edge.p2 : edge.p1)

export const separateMeshes: SeparateMeshes = ({ nodes, edges }) => {
  const meshes: Mesh[] = []
  const nodeHomes: Map<string, Mesh> = new Map()
  for (const origin of nodes.values()) {
    if (nodeHomes.has(origin.id)) continue
    meshes.push({ nodes: new Map(), edges: new Map() })
    const mesh = meshes[meshes.length - 1]
    const nodeQueue: Node2dExtracted[] = [origin]
    const timeStart = performance.now()
    while (nodeQueue.length > 0) {
      if (performance.now() - timeStart > 1000) {
        console.warn(`separateMeshes: timeout`)
        break
      }
      const node = nodeQueue.pop()
      if (!node) continue
      nodeHomes.set(node.id, mesh)
      mesh.nodes.set(node.id, node)
      const connectedEdges = node.edgeIds.map((edgeId) => {
        const edge = edges.get(edgeId)
        if (!edge) throw new Error(`${edgeId} not found`)

        return edge
      })
      for (const edge of connectedEdges) {
        const nodeB = getNodeB(node, edge)
        mesh.edges.set(edge.id, edge)
        mesh.nodes.set(nodeB.id, nodeB)
        if (!nodeHomes.has(nodeB.id)) nodeQueue.push(nodeB)
      }
    }
  }

  return meshes
}
